import React from 'react'
import ItemQuestion from '../components/Faqs/ItemQuestion'
import dataFaqs from '../data/faqs'

const Faqs = () => {
  return (
    <>
      <div className='container mbt-10em'>
        {/* Titulo */}
        <div className='row mb-5'>
          <div className='col'>
            <h3 className='text-center font-weight-bold'>
              Preguntas frecuentes
            </h3>
          </div>
        </div>
        {dataFaqs.map(item => (
          <ItemQuestion item={item} />
        ))}
      </div>
    </>
  )
}

export default Faqs
